import { GetSiteInfoResponse } from "../entities/CollectEntities";
import { executeGet } from "./ServiceHelper";

export function getSiteInfo(code:string): Promise<GetSiteInfoResponse> {
    return executeGet<GetSiteInfoResponse>("api/collect/siteInfo?code=" + code);
}